export default "__VITE_ASSET__044abda0__"